module.exports = __webpack_public_path__ + "90d4f56b8637a9e88f98ade5961dc061.svg";